export default {
  account_required: 'Mangyaring maglagay ng pangalan ng tagagamit.',
  password_required: 'Mangyaring maglagay ng password.',
  confirm_password_different: 'Hindi pareho ang Confirm Password at Password.',
  min_length: "Dapat mayroong 6 na titik o higit pa.",
  alphanumeric_char: "Tatanggapin lamang ang mga alphanumerikong karakter.",
  numeric_char: "Tatanggapin lamang ang mga numero bilang karakter.",
  list:{
    0: "Ang iyong sesyon ay nag-expire, mangyaring mag-login muli.",
    disconnect: "Mangyaring suriin ang iyong koneksyon at subukan muli.",
    OK: "Matagumpay na naipadala ang OTP Code.", // for OTP
    ok: "Matagumpay na naipadala ang OTP Code.", // for OTP
    CLOSE: "Ang iyong account ay ipinasara dahil sa paglabag sa mga Patas na Patakaran sa Paglalaro ng EpicWin.",
    close: "Ang iyong account ay ipinasara dahil sa paglabag sa mga Patas na Patakaran sa Paglalaro ng EpicWin.",
    accountIdRequired: 'Mangyaring maglagay ng pangalan ng tagagamit.',
    passwordStrengthError: 'Lumikha ng iyong sariling password. Ang password ay dapat may 6-20 na titik at numero.',
    session_expired : 'Nag-expire na ang sesyon.',

    app_id_required: "Application ID is required",
    permission_denied: "Hindi pinapahintulutan",
    account_id_required: "Kinakailangan ang Username/Account ID",
    verification_code_required: "Kinakailangan ang verification code",
    account_not_exists: "Ang Username/Account ay hindi umiiral",
    account_inactive: " Ang Username/Account ay hindi aktibo",
    verify_failed: "Nabigo ang proseso ng pag-verify",
    parent_account_inactive: "Parent account is inactive",
    transfer_id_required: "Transfer ID is required",
    credit_amount_required: "Kinakailangan ang halagang kredito",
    duplicate_credit_record: "Dobleng talaan ng kredito",
    member_wallet_not_exists: "Walang umiiral na pitaka ng miyembro",
    debit_amount_required: "Debit amount is required",
    duplicate_debit_record: "Duplicated debit record",
    insufficient_balance: "Kulang ang available na balanse",
    result_exists: "May umiiral nang talaan ng resulta",
    debit_record_not_found: "Hindi natagpuan ang talaan ng debit",
    bank_id_required: "Kinakailangan ang ID ng bangko",
    bank_acc_no_required: "Kinakailangan ang numero ng bankong account",
    bank_acc_holder_required: "Kinakailangan ang pangalan ng may-ari ng bankong account",
    bank_already_setup: "Ang bankong account ay naka-set up na",
    platform_required: "Kinakailangan ang plataporma",
    parent_not_exists: "Parent does not exist",
    invalid_password: "Hindi wastong username/password",
    parent_id_required: "Parent ID is required",
    password_required: "Kinakailangan ang password",
    contact_phone_required: "Kinakailangan ang numero ng telepono ng kontakto",
    account_exists: "Mayroon nang umiiral na User/Account ID",
    vip_mode_not_exists: "VIP mode does not exist",
    session_not_exists: "Nag-expire na ang iyong sesyon, mangyaring mag-login muli.",
    ticket_id_required: "Kinakailangan ang ID ng tiket",
    ref_id_required: "Kinakailangan ang ID ng sanggunian",
    ticket_not_exists: "Hindi umiiral ang tiket",
    ticket_processed: "Ang tiket ay na-process na",
    min_deposit_not_met: "Ang halaga ng deposito ay dapat hindi bababa sa minimum na halaga",
    ongoing_promotion: "Mayroon kang kasalukuyang promosyon. Mangyaring mag-claim muli mamaya.",
    invalid_promo_package: "Hindi wastong package ng promosyon",
    promo_min_deposit_not_met: "Ang halaga ng deposito ay hindi nakakatugma sa minimum na halaga ng promosyon",
    claim_promo_only_once_a_day: "Ang promosyon ay maaring ma-claim lamang isang beses sa isang araw",
    first_deposit_unmet: "Ang araw-araw na unang gantimpala sa deposito ay na-claim na",
    newbie_unmet: "Ang gantimpalang deposito para sa mga baguhan ay na-claim na",
    claim_promo_only_once: "Ang promosyon ay maaring ma-claim lamang isang beses",
    inner_catch: "Hindi inaasahang error",
    systemError: "Error ng sistema",
    SystemError: "Error ng sistema",
    deposit_amount_required: "Kinakailangan ang halaga ng deposito",
    target_bank_id_required: "Kinakailangan ang target bank ID",
    target_bank_acc_no_required: "Kinakailangan ang numero ng target bank account",
    target_bank_acc_holder_required: "Kinakailangan ang pangalan ng may-ari ng target bank account",
    deposit_date_required: "Kinakailangan ang petsa ng deposito",
    deposit_method_required: "Kinakailangan ang paraan ng deposito",
    min_deposit_not_set: "Hindi pa itinatakda ang minimum na halaga ng deposito",
    min_balance_not_set: "Hindi pa itinatakda ang minimum na available na balanse",
    ibank_account_not_exists: "IBANK88 account does not exist",
    ibank_account_inactive: "IBANK88 account is inactive",
    withdrawal_amount_required: "Kinakailangan ang halaga ng pagwiwithdraw",
    min_withdrawal_not_set: "Hindi pa itinatakda ang minimum na halaga ng pagwiwithdraw",
    bank_member_not_exists: "Hindi umiiral ang target member bank account",
    promotion_requirement_not_met: "Mayroon ka pang kasalukuyang promosyon",
    invalid_promotion: "Hindi wastong promosyon",
    new_password_required: "Kinakailangan ang bagong password",
    multiplier_not_found: "Hindi kayang i-process ng sistema ang iyong request sa ngayon, subukang muli mamaya",
    contact_phone_exists: "Ang teleponong ito ay may rehistrasyon na",
    BLOCK: "Ang iyong account ay pansamantalang na-suspend",
    tac_is_valid: "Ang iyong nakaraang OTP ay wasto pa",
    tac_expired: "Ang iyong OTP code ay nag-expire na. Mangyaring humiling ng bagong OTP code.",
    invalid_tac: "Hindi wastong OTP code",
    tac_not_validate: "Hindi pa naverify ang OTP code",
    tacCodeRequired: "Mangyaring maglagay ng OTP code",
    invalid_referral_code: "Hindi wastong referral code",
    exceed_max_withdrawal: "Lumampas sa maximum na halaga ng pagwiwithdraw",
    bank_member_inactive: "Hindi aktibo ang banko ng tagagamit",
    loginFailed: "Nabigo sa pag-login",
    loginSucceed: "Matagumpay na nag-login",
    usernameRequired : "Mangyaring maglagay ng pangalan ng tagagamit",
    passwordRequired : "Mangyaring maglagay ng password",
    logoutSucceed : "Matagumpay na nag-logout",
    logoutFailed : "Nabigo sa pag-logout",
    requestSucceed: "Tagumpay ang request",
    requestFailed : "Nabigo ang request",
    requestProcessing : "Kasalukuyang ini-process ang iyong request",
    requestDelayed: "Nagkakaroon ng pagkaantala sa request",
    verificationCodeRequired: "Kinakailangan ang Verification OTP",
    newPasswordRequired: "Kinakailangan ang bagong password",
    bankIdRequired: "Mangyaring pumili ng bangko",
    bankNameRequired: "Kinakailangan ang pangalan ng bangko",
    bankAccHolderRequired : "Kinakailangan ang pangalan ng may-ari ng bangko",
    bankAccNoRequired: "Kinakailangan ang numero ng bankong account",
    depositAmountRequired: "Mangyaring maglagay ng halaga ng deposito",
    dateRequired: "Mangyaring pumili ng petsa",
    bonusIdRequired: "Mangyaring pumili ng regalo na nais makuha",
    bank_member_exists: "Ang bankong account ay may rehistrasyon na",
    never_deposited : "Dapat kang mag-deposito ng hindi bababa sa isa bago ka makapag-transfer ng pera sa iyong mga kaibigan",
    transferAmountMustGreaterThanEqual5: "Transfer amount must be greater or equal PHP 5",
    invalid_transfer_amount: "Transfer amount must be greater or equal PHP 5",
    // account_not_exists : "account not exists"
    ongoing_promotion : "Mayroon ka pa ring kasalukuyang promosyon",
    insufficient_balance : "Kulang na balanse",
    transfer_success: "Matagumpay na napadala",
    sender_id_required: "Sender ID required",
    recipient_id_required: "Recipient ID required",
    tac_validated: "Na-validate na ang OTP Code. Mangyaring humiling muli.",
    pending_result_in_game: "Naghihintay ng resulta sa laro",
    accountIdOnlyNumber: "Tatanggapin lamang ang wastong numero ng telepono",
    unfinishgamedetected: "Mangyaring tapusin ang iyong libreng laro bago magpatuloy sa hakbang na ito",
    duplicate_review: "Ibinoto mo na ang iyong pagsusuri kanina",
    exceed_withdrawal_frequency: "Lumampas ka na sa araw-araw na limitasyon sa pagwiwithdraw. (5 beses bawat araw)",
    requestTooFrequentAtLeast2Minutes: "Kasalukuyang ini-process ang iyong request",
    invalidPhoneNumberFormat: "Hindi wastong format ng numero ng telepono",
    fpayUnderMaintenance: "Ang sistema ay nasa ilalim ng pagmamantina",
    affiliate_not_exists: " Hindi umiiral ang affiliate",
    phoneRequired: ' Mangyaring maglagay ng numero ng telepono',
    couponeCodeRequired: "Kinakailangan ang code ng kupon",
    coupon_code_required: "Kinakailangan ang code ng kupon",
    coupon_not_available: "Hindi magamit ang code ng kupon",
    contact_email_registered: "Mayroon nang umiiral na email",
    invalidEmailFormat: "Hindi wastong format ng email",
    emailRequired: "Kinakailangan ang email",
    paymentMethodRequired: "Mangyaring pumili ng paraan ng pagbabayad",
    depositMethodRequired: "Mangyaring pumili ng paraan ng pagdedeposito",
    no_changes: "Nanatili ang umiiral na default na bangko",
    resultIdRequired: "Kinakailangan ang ID ng resulta",
    free_credit_detected: "Deposit para makapaglaro",
    unableToLaunchSlotGameAtTheMoment: "Hindi maaring buksan ang laro sa ngayon.",

    //new
    amount_required: "Kinakailangan ang halaga.",
    auth_token_required: "Kinakailangan ang token ng sesyon.",
    bet_id_required: "Kinakailangan ang ID ng bet.",
    bonus_unavailable: "Hindi magagamit ang bonus.",
    client_ip_required: "Kinakailangan ang IP ng kliyente.",
    first_deposit_not_met: "Kinakailangan ang unang deposito.",
    ftd_required: "Kinakailangan ang unang deposito.",
    game_maintenance: "Kasalukuyang nasa ilalim ng pagmamantina, pakisubukan muli mamaya.",
    gateway_acc_required : "Kinakailangan ang account ng gateway.",
    inbox_id_required: "Kinakailangan ang ID ng inbox.",
    insufficient_rebate: "Kulang na rebate.",
    insufficient_ticket: "Kulang na tiket.",
    is_default_required: "Kinakailangan ang umiiral na pagpili.",
    min_withdrawal_not_met: "Hindi natutugma ang minimum na halaga ng pagwiwithdraw.",
    newbie_not_met: "Hindi natutugma ang newbie.",
    no_changes: "Nanatili ang umiiral na default na bangko.",
    promotion_not_available:"Hindi magagamit ang promosyon.",
    ref_no_required: "Kinakailangan ang numero ng sanggunian.",
    result_id_required: "Kinakailangan ang ID ng resulta.",
    search_id_required: "Search ID required",
    setting_not_set: "Setting not configured",
    tac_required: "Kinakailangan ang code ng OTP",
    ticket_count_required: "Kinakailangan ang halaga ng tiket.",
    vip_not_exists: "Not a VIP member",
    working_date_required: "Kinakailangan ang petsa ng pagtatrabaho.",
    working_month_required: "Kinakailangan ang buwan ng pagtatrabaho.",
    withdrawal_amount_lte_withhold_amount: "Ang halaga ng pagwiwithdraw ay mas mababa o pantay sa halaga ng itinatago.",
    providerRequired: "Kinakailangan ang nagbibigay ng serbisyo.",
    invalid_contact_email: "Hindi wastong email.",
    invalidUsernameFormat: "Hindi wastong format ng pangalan ng tagagamit.",
    affiliate_inactive: "Hindi aktibo ang affiliate.",
    insufficient_token: "Kulang na token.",
    otpRequired: "Kinakailangan ang OTP",
    undefined: "Mangyaring suriin ang iyong koneksyon at subukan muli.",
    failedtolaunchpaymentgateway: "Kasalukuyang nasa ilalim ng pagmamantini, pakisubukan muli mamaya.",
    bank_member_full : "Abot na sa maksimum kapasidad ng mga bank account (10 accounts)",
    bank_acc_holder_not_same: "Hindi wastong pangalan ng account",
    member_ewallet_exists: "Mayroon nang umiiral na E-Wallet account",
    member_ewallet_full: "Nakamit na ang maksimum kapasidad ng mga E-Wallet account (10 E-Wallet accounts)",
    invalid_bank_id: "Hindi wastong Bangko/E-Wallet",
    verification_failed: "Hindi wastong username/ numero ng telepono",
    depositAmountMustGreaterThan0: "Ang Halaga ng Deposito ay dapat na mas malaki kaysa sa 0.",
    depositAmountMustGreaterThanMin: "Ang Halaga ng Deposito ay dapat na mas malaki kaysa sa minimum na kinakailangan.",
    depositAmountMustLessThanMax: "Ang Halaga ng Deposito ay hindi maaaring lumampas sa maksimum na limitasyon",
    favourite_game_exists: "Nasa listahan ng mga paboritong laro.",
    pending_deposit: "Hinihintay na deposito",
    "Incoming Request Info Incomplete" : "Incoming Request Info Incomplete",
    "Invalid Player": "Invalid Player",
    "Invalid Auth Token" : "Invalid Auth Token",
    "Create Account Failed": "Create Account Failed",
    "Launch Game Failed" : "Launch Game Failed",
    "Invalid Type" : "Invalid Type",
    "Invalid Lang" : "Invalid Lang",
    "System Error" : "System Error",
    "Get Game List Failed": "Get Game List Failed",
    "Invalid PlayerId": "Invalid PlayerId",
    "Invalid TicketId": "Invalid TicketId",
    "Get Bet Detail Url Failed": "Get Bet Detail Url Failed",
    launch_fail: "May error sa paglulunsad ng laro, mangyaring makipag-ugnayan sa admin",
    playerCreatedError: "May error sa paglulunsad ng laro, mangyaring makipag-ugnayan sa admin",
    "Launch Fail": "May error sa paglulunsad ng laro, mangyaring makipag-ugnayan sa admin",
    "SERVER BUSY": "May error sa paglulunsad ng laro, mangyaring makipag-ugnayan sa admin",
    currencyNotSupported : "Hindi suportadong pera",
    game_not_supported:"Hindi suportado ang laro sa bonus na iyong nakuha.",
    "game house is not enable": "Ang game house ay hindi naka-enable"
  },
  success_claim: "Tingnan ang reklamo sa pitaka",

  newpw_required: "Mangyaring maglagay ng bagong password.",
  newpw_notsame: "Hindi puwedeng pareho ang bagong password at kasalukuyang password.",
  newpw_alphanumeric: "Ang bagong password ay dapat kombinasyon ng mga titik at numero.",

  oldpw_required: "Mangyaring maglagay ng kasalukuyang password.",

  pw_notmatched: "Hindi tumutugma ang kumpirmasyon ng password sa bagong password.",

  forgot_password_success: "Matagumpay na na-update ang password!!",
  change_password_success: "Matagumpay na na-update ang password!!",
  add_bank_success: "Matagumpay na idinagdag ang bagong bankong account!!",
  add_wallet_success: "Bagong E-Wallet na idinagdag nang matagumpay!!",
  set_default_success: "Matagumpay na itinakda bilang default!!",
  update_success:"Matagumpay na na-update",

  tac_tooltips: "Naipadala na ang OTP Code sa iyong numero ng kontakto.",
  tac_tooltips1: 'I-click ang "Resend" para makakuha ng bagong OTP Code.',
  tac_countdown: "Ipadala muli sa loob ng {countdown}.",

  bank_details_tooltips: "Ang iyong transaksyon ng pagwiwithdraw ay tatanggihan kung magkaiba ang pangalan ng iyong bankong account mula sa iyong rehistradong buong pangalan sa EpicWin.",
  copy_clipboard: "Link na-kopya.",

  wrong_filetype: "Wrong Filetype",
  
};
